var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnBookmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3021 3.65625L16.1354 7.32292C16.3854 7.83333 17.0521 8.32292 17.6146 8.41667L20.9375 8.96875C23.0625 9.32292 23.5625 10.8646 22.0312 12.3854L19.4479 14.9688C19.0104 15.4063 18.7708 16.25 18.9062 16.8542L19.6458 20.0521C20.2292 22.5833 18.8854 23.5625 16.6458 22.2396L13.5312 20.3958C12.9687 20.0625 12.0417 20.0625 11.4687 20.3958L8.35416 22.2396C6.125 23.5625 4.77083 22.5729 5.35416 20.0521L6.09375 16.8542C6.22916 16.25 5.98958 15.4063 5.55208 14.9688L2.96875 12.3854C1.44791 10.8646 1.9375 9.32292 4.0625 8.96875L7.38541 8.41667C7.9375 8.32292 8.60416 7.83333 8.85416 7.32292L10.6875 3.65625C11.6875 1.66667 13.3125 1.66667 14.3021 3.65625Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnBookmarkIcon);
export default __webpack_public_path__ + "static/media/UnBookmarkIcon.0815d2f4941b5c6276771d91225e2e22.svg";
export { ForwardRef as ReactComponent };